<template lang='pug'>
	.extended-forms
		n-h-chart(:chart-options="headerChart" :ref="headerChart.dataKey")
		// 1 - Выбор периода
		.container-fluid
			period-selector(
				@select-date="selectChartPeriod"
				@select-custom-date="selectCustomDate"
			)
			//test
			// 1 - /Выбор периода
			// 2 - Компания
			.row.align-items-center
				.col
				.col-8
					.white_block
						.company-text.text-left.d-inline-block
							.company-bodyText.font-weight-bold(style="font-size: 2.5rem;") {{company.company}}
								<i class="fas fa-pencil-alt" v-on:click="updateName()"></i>
							.formlink
								<i class="fas fa-globe-americas"></i>
								a(:href="company.formlink" target="_blank") {{company.formlink}}
							//- .company-sub-text.text-muted
							//-   | {{company.companySubText}}
							//- .company-sub-text.text-muted
							//-   | {{company.companySubText2}}
				.col

		// 2 - /Компания

		// 2 - Аналитика
		.container
			.row
				.col-12.mt-5.mb-4
					h1.main_header {{date}}

				.col-sm-12.col-md-6.col-lg-4(v-for='info in analytics')
					.white_block.text-center.px-3.py-5.h-100
						.my-info {{info.value}}
						.my-main.mt-2 {{info.text}}
				.col-12.col-lg-4
					.white_block.small_block(type="age")
						.value.my-info {{ageChart.value}}
						.text {{ageChart.text}}
					.white_block.small_block(type="gender")
						.value.my-info {{genderChart.value}}
						.text {{genderChart.text}}
				.col-12.col-lg-4
					.white_block.small_block(type="birthdays")
						.value.my-info {{birthdays.value}}
						.text {{birthdays.text}}

				//- .col-12.col-lg-4.my-auto
				//- 	.white_block.small_block(type="birthdays")
				//- 		.value.my-info {{birthdays.value}}
				//- 		.text {{birthdays.text}}
			//- .row
			//- 	.col-12.col-lg-4.mt-4.pt-lg-4.os-chart
			//- 		chart(:options="osChart.options" autoresize)
			//- 	.col-12.col-lg-3


		// 2 - /Аналитика


</template>
<script>
import PeriodSelector from "src/components/Actid/Components/PeriodSelector";
import nHChart from "src/components/Actid/Components/HeaderChart";
import moment from "moment";
var apiDriver = require("../../apiDriver").default;
// (async () => {
//   var x = await apiDriver.default.statisctics.all();
//   console.log("x:", x);
// })()

import ECharts from "vue-echarts";

import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/timeline";
import { DatePicker } from "element-ui";

export default {
	components: {
		PeriodSelector,
		nHChart,
		chart: ECharts
	},
	computed: {},

	data() {
		return {
			date: "Статистика за 14 дней",

			animated: 0,

			loadings: {
				pageInfo: false
			},
			company: {
				avatar: "/assets/actid/company-logo.png",
				company: "...",
				companySubText: "...",
				companySubText2: "...",
				formlink: "..."
			},
			analytics: [
				{
					text: "Карт было выдано за период",
					value: "..."
				},
				// {
				//   text: "Отправлено пушей за период",
				//   value: "..."
				// },
				// {
				//   text: "Раз сканируют тейблтенты",
				//   value: "..."
				// }
			],
			headerChart: {
				dataKey: "headerChart",
				data: [],
				xaxis: []
			},

			osChart: {
				options: {
					tooltip: {
						trigger: "item",
						formatter: "{b}: {c}"
						// formatter: "{b} : {c}%"
					},
					series: [
						{
							name: "Series name",
							type: "pie",
							label: {
								normal: {
									show: true
								},
								emphasis: {
									show: true
								}
							},
							data: [
								{
									value: 50,
									name: "iOS",
									itemStyle: {
										color: {
											type: "linear",
											x: 0,
											y: 0,
											x2: 2,
											y2: 2,
											colorStops: [
												{
													offset: 0,
													color: "#64b5f6" // color at 0% position
												},
												{
													offset: 1,
													color: "#ba68c8" // color at 100% position
												}
											]
										}
									}
								},
								{
									value: 50,
									name: "Android",
									itemStyle: {
										color: {
											type: "linear",
											x: 0,
											y: 0,
											x2: 2,
											y2: 2,
											colorStops: [
												{
													offset: 0,
													color: "#81c784" // color at 0% position
												},
												{
													offset: 1,
													color: "#4db6ac" // color at 100% position
												}
											]
										}
									}
								}
							]
						}
					]
				}
			},

			ageChart: {
				text: "Средний возраст гостя",
				value: "..."
			},
			genderChart: {
				text: "Ваш основной контингент",
				value: "..."
			},

			birthdays: {
				text: "Дней рождений сегодня",
				value: "..."
			}
		};
	},

	mounted() {
		console.log("this:", this);

		this.updateStatistics();
		this.loadAccount();
	},

	methods: {
		updateStatistics(from, to) {
			this.showGraph(from, to);
			// this.loadPushesCount(from, to);
			this.loadCardsCount(from, to);
			// this.loadQRScans(from, to);
			this.loadAverage(from, to);
			// this.loadDevices(from, to);
			this.loadBirthdays();
		},

		async updateName(){
			let x = prompt("Введите новое название заведения:", this.company.company);
			if(!x) return;
			this.company.company = x;
			await apiDriver.services.api.post("cards", "wallet/shopName", {name: x});
		},

		async loadBirthdays() {
			var birthdays = await apiDriver.services.api.get('cards', 'wallet/birthdays', {from: moment(), to: moment().add(1,'day')});
			birthdays = birthdays.data;
			this.birthdays.value = birthdays.birthdays.length;
			this.birthdays.text = declOfNum(birthdays.birthdays.length, [
				"День рождения сегодня",
				"Дня рождения сегодня",
				"Дней рождений сегодня"
			]);
			console.log("birthdays:", birthdays);
		},

		async loadPushesCount(from = moment().add(-14, "days"), to = moment()) {
			var pushes = await apiDriver.statistics.cards.pushes_sent_count(from, to);
			this.analytics[1].value = pushes.count;
			console.log("pushes count:", pushes);
		},

		async loadCardsCount(from = moment().add(-14, "days"), to = moment()) {
			var cards = await apiDriver.services.api.get('cards', 'stats/cards_amount', {from, to});
			this.analytics[0].value = cards.data.amount;
			console.log("cards count:", cards);
		},

		async loadAverage(from = moment().add(-14, "days"), to = moment().add(1,'day')) {
			var age = await apiDriver.services.api.get('cards', 'wallet/average_age', {from, to});
			age = age.data;
			var gender = await apiDriver.services.api.get('cards', 'wallet/average_gender', {from, to});
			gender = gender.data;
			this.ageChart.value = age.age || `¯\\_(ツ)_/¯`;
			if(gender.male_count == 0 && gender.female_count == 0){
				this.genderChart.value = `¯\\_(ツ)_/¯`;
			}else{
				this.genderChart.value = gender.male_count > gender.female_count ? "Мужчины" : "Женщины";
			}
			console.log("average:", age, gender);
		},

		async loadDevices(from = moment().add(-30, "days"), to = moment()) {
			var devices = await apiDriver.statistics.cards.devices(from, to);
			console.log("devices:", devices);
			this.osChart.options.series[0].data[0].value = devices.ios_count;
			this.osChart.options.series[0].data[1].value =
				devices.all_count - devices.ios_count;
		},

		async loadAccount() {
			var account = await apiDriver.account();
			let formlink_req = await apiDriver.services.api.get("cards", "wallet/formlink");
			let shopSettings = await apiDriver.services.api.get("cards", "wallet/shopSettings");
			// console.log("shopSettings:", );
			this.company.formlink = formlink_req.data.formlink;
			this.company.company = shopSettings.data.settings.name;
			this.company.companySubText =
				"Баланс: " +
				account.finance.balance.real +
				" руб. \\ " +
				account.finance.balance.bonus +
				" " +
				declOfNum(account.finance.balance.bonus, [
					"бонус",
					"бонуса",
					"бонусов"
				]);

			if (account.finance.days_left.all_balances == 0) {
				this.company.companySubText2 =
					"Рекомендуем Вам пополнить личный кабинет для стабильной работы сервисов.";
			} else {
				this.company.companySubText2 =
					"Этого хватит примерно на " +
					account.finance.days_left.all_balances +
					" дн.";
			}
		},

		enter: function(el, done) {
			el.style.opacity = 0;
			el.classList.add("animated");
			setTimeout(() => done(), 180 * this.animated++);
		},

		afterEnterFadeInUp: function(el) {
			el.classList.add("fadeInUp");
		},

		async showGraph(
			date_start = moment().add(-14, "days"),
			date_end = moment()
		) {
			let array = (await apiDriver.services.api.get('cards', 'stats/cards_amount_per_day', {from: date_start, to: date_end})).data.amount.stats;

			// add empty days
			for(let c = date_start; c<date_end; c.add(1, 'day') ){
				let c_d = c.format("YYYY-MM-DD");
				if(!array.find(x=>x.date==c_d)) array.push({amount: 0, date: c_d});
			}

			array = array.sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf())

			console.log("cards stats:", array);

			let values = array.map(x => x.amount);
			let xaxis = array.map(x =>
				moment(x.date, "YYYY-MM-DD").format("YYYY.MM.DD")
			);

			let counter = 0;
			let res_values = [];
			for (let v of values) res_values.push({ value: v, label: { show: true } });

			this.headerChart.data = values;
			this.headerChart.xaxis = xaxis;

			// console.log(values, this.headerChart.xaxis);

			this.drawChart();
		},

		drawChart() {
			this.$refs.headerChart.$refs.chart.options.series[0].data = this.headerChart.data;
			this.$refs.headerChart.$refs.chart.options.xAxis.data = this.headerChart.xaxis;
			console.log("drawChart:", this.headerChart.xaxis, this.headerChart.data);
		},

		selectChartPeriod(days) {
			if (days == 30) {
				// this.showGraph(moment().add(-30, "days"));
				this.selectCustomDate({
					from: moment()
						.add(-30, "days")
						.toDate(),
					to: moment().toDate()
				});
				this.date = "За месяц";
			} else if (days == 7) {
				// this.showGraph(moment().add(-7, "days"));
				this.selectCustomDate({
					from: moment()
						.add(-7, "days")
						.toDate(),
					to: moment().toDate()
				});
				this.date = "За неделю";
			}
		},

		selectCustomDate({ from, to }) {
			this.date =
				"С " +
				moment(from).format("DD.MM.YY") +
				" по " +
				moment(to).format("DD.MM.YY");
			this.updateStatistics(moment(from), moment(to));
		}
	}
};

function declOfNum(number, titles) {
	var cases = [2, 0, 1, 1, 1, 2];
	return titles[
		number % 100 > 4 && number % 100 < 20
			? 2
			: cases[number % 10 < 5 ? number % 10 : 5]
	];
}
</script>
<style scoped lang="sass">
	.white_block
		background: white;
		margin: 5px;
		padding: 10px 20px;
		border-radius: 4px;
		box-shadow: 0 8px 20px rgba(0,0,0,0.1);
		margin-bottom: 7px;
		&.small_block
			margin-top: 20px;

	.formlink i
		margin-right: 5px;
		font-size: 13px;
		color: #d2d2d2;
	.formlink a
		color: #8e8e8e;
	.formlink a:hover
		color: black;

	.company-bodyText
		color: #6c61c1;
		margin-top: -10px;

	.main_header
		font-size: 2.5rem;
		text-transform: uppercase;
		color: #4c4c4c;
		text-align: center;
		margin-bottom: 30px;
		font-weight: bold;

	.my-main
		font-size: 1.5rem


	.my-info
		font-size: 2em;


	.echarts
		height: 350px
		max-width: 400px
		left: -30px;
	.os-chart
		
	.os-text
		font-weight: bold
		font-size: 1.6rem

	.text-box
		width: 175px
		color: white
		font-weight: bold
		max-height: 80%

	.info_circle
		background: white;
		border-radius: 4px;
		box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
		cursor: default;
		margin-top: 70px;
		padding: 20px 40px;
		max-width: 350px;

	.company-bodyText i
		font-size: 12pt;
		color: #c5c5c5;
		position: relative;
		top: -6px;
		margin-left: 10px;
		cursor: pointer;
	.company-bodyText i:hover
		color: #6c60c1;

</style>
